import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import Guest from 'src/components/Guest';

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

const Login = Loader(lazy(() => import('src/content/pages/Auth/Login')));
const RecoverPassword = Loader(lazy(() => import('src/content/pages/Auth/RecoverPassword')));

const accountRoutes = [
  {
    path: 'login',
    element: (
      <Guest>
        <Login />
      </Guest>
    )
  },
  {
    path: 'recover-password',
    element: <RecoverPassword />
  }
];

export default accountRoutes;
